import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const activityBeneficiariesDeliveriesRoutes: MenuInterface[] = [
    {
        code: 'Deliver',
        route: [
            {
                content: '$type/deliveries/deliver',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'DeliveriesList',
        route: [
            {
                content: '$type/deliveries/list',
                focus: 'empty',
            }, 'content'
        ],
    }
];
